import { render, staticRenderFns } from "./ComplianceForm.vue?vue&type=template&id=446a6674&scoped=true"
import script from "./ComplianceForm.vue?vue&type=script&lang=js"
export * from "./ComplianceForm.vue?vue&type=script&lang=js"
import style0 from "./ComplianceForm.vue?vue&type=style&index=0&id=446a6674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446a6674",
  null
  
)

export default component.exports